<script>
import TimelineActionBar from 'vcomponents/timeline/timelineActionBar/TimelineActionBar.vue';

export default {
    name: 'TimelineActionBarTask',
    extends: TimelineActionBar,
    computed: {
        // eslint-disable-next-line vue/no-unused-properties
        canDelete() {
            return this.oneLog.can_edit;
        },
        // eslint-disable-next-line vue/no-unused-properties
        canEdit() {
            return this.oneLog.can_edit;
        },
    },
    methods: {
        previewElement(onelog) {
            if (this.isNewPanelEnabled) {
                this.openDetail(
                    'task',
                    () =>
                        EventBus.emit('timeline:refreshLog', {
                            objectType: onelog.objecttype,
                            objectId: onelog.objectid,
                        }),
                    () => EventBus.emit('timeline:refresh'),
                    (data) => {
                        EventBus.emit('timeline:processAndAdd', {
                            entity: 'task',
                            event: 'task.created',
                            objectid: data.id,
                        });
                    },
                );
            } else {
                const can_edit = onelog.can_edit ? 'Y' : 'N';
                Agenda.cardForm(
                    onelog.objectid,
                    0,
                    'task',
                    can_edit,
                    false,
                    onelog.start,
                    onelog.end,
                    'N',
                    onelog.objecttype,
                );
            }
        },
        editElement(onelog) {
            Activities.openActivityForm(
                onelog.objectid,
                null,
                onelog.relatedtype,
                () =>
                    EventBus.emit('timeline:refreshLog', {
                        objectType: onelog.objecttype,
                        objectId: onelog.objectid,
                    }),
                'task',
            );
        },
        deleteElement(onelog) {
            Agenda.deleteAlert(
                onelog.objectid,
                0,
                false,
                'N',
                onelog.objecttype,
                '',
                '',
                onelog.title,
            );
        },
    },
};
</script>
